<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30">
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-green">
                            <div class="card-icon">
                                <md-icon>open_book</md-icon>
                            </div>
                            <h4 class="title">Contribution Page</h4>
                        </md-card-header>
                        <md-card-content>
                            <md-table>
                                <md-table-row>
                                    <md-table-cell>Name</md-table-cell>
                                    <md-table-cell>{{contribution.name}}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell>VAT:</md-table-cell>
                                    <md-table-cell>
                                        <p v-html="contribution.vat+'%'"></p>
                                    </md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell>With Holding Tax:</md-table-cell>
                                    <md-table-cell>
                                        <p v-html="contribution.withholding_tax+'%'"></p>
                                    </md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell>Active:</md-table-cell>
                                    <md-table-cell>
                                        <p v-if="contribution.is_active"> Yes </p>
                                        <p v-else> No</p>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                            <md-button class="md-white md-primary md-dense"
                                       @click="goToEdit(contribution.id)"
                                       style="margin: 0.2rem"
                            >Edit Contribution
                            </md-button>
                            <md-button v-if="!contribution.is_active &&can('update-tariff')"
                                       class="md-white md-success md-dense"
                                       @click="update"
                                       style="margin: 0.2rem"
                            >Activate Contribution
                            </md-button>
                            <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>

                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </div>

        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-70">
            <nav-tabs-card>
                <template slot="content">
                    <span class="md-nav-tabs-title"></span>
                    <md-tabs class="md-info md-white" md-alignment="left">
                        <md-tab id="tab-pages" md-label=" Tariff Rates" md-icon="dollar">
                            <!--                                            pagination table starts here-->
                            <md-card>
                                <!--                                <md-card-header class="md-card-header-icon md-card-header-green">-->
                                <!--                                    <div class="card-icon">-->
                                <!--                                        <md-icon>money</md-icon>-->
                                <!--                                    </div>-->
                                <!--                                    <h4 class="title" v-if="!isEditingNewTag">List of  Activity Tariff Rates</h4>-->
                                <!--                                    <h4 class="title" v-else>Add Activity Tariff Rate</h4>-->
                                <!--                                </md-card-header>-->
                                <md-card-content>
                                    <div class="text-right" v-if="!isEditingNewTag">
                                        <md-button v-if="can('create-activity-tariff')"
                                                   @click="addNewActivityTariffRate()" class="md-primary md-dense">
                                            Add Contribution Item Rate
                                        </md-button>
                                    </div>
                                    <div v-if="isEditingNewTag">
                                        <md-card>
                                            <form @submit.prevent="add">

                                                <md-card-content>
                                                    <div class="md-layout spacing">
                                                        <label class="md-layout-item md-size-25 md-form-label">
                                                            Item Name:
                                                        </label>
                                                        <div class="md-layout-item">
                                                            <select-input
                                                                    v-model="contributionItem.id"
                                                                    deselect-label="Can't remove this value"
                                                                    track-by="id"
                                                                    label=""
                                                                    placeholder="Select  Activity"
                                                                    :options="activityList"
                                                                    :allow-empty="false">
                                                            </select-input>
                                                        </div>
                                                    </div>

                                                    <br>
                                                    <div class="md-layout">
                                                        <label class="md-layout-item md-size-25 md-form-label">
                                                            Amount
                                                        </label>
                                                        <div class="md-layout-item">
                                                            <md-field class="md-invalid">
                                                                <md-input v-model="activityNewRate.amount" type="number"
                                                                          required/>
                                                            </md-field>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <div class="md-layout">
                                                        <label class="md-layout-item md-size-25 md-form-label">
                                                            Weekend Amount
                                                        </label>
                                                        <div class="md-layout-item">
                                                            <md-field class="md-invalid">
                                                                <md-input v-model="activityNewRate.weekend_amount"
                                                                          type="number" required/>
                                                            </md-field>
                                                        </div>
                                                    </div>
                                                    <div class="md-layout spacing">
                                                        <label class="md-layout-item md-size-25 md-form-label">
                                                            Active
                                                        </label>
                                                        <div class="md-layout-item">
                                                            <md-field>
                                                                <label>Select ...</label>
                                                                <md-select v-model="activityNewRate.is_active"
                                                                           name="is_active">
                                                                    <md-option value=1>Yes</md-option>
                                                                    <md-option value=0>No</md-option>
                                                                </md-select>
                                                            </md-field>
                                                        </div>
                                                    </div>
                                                </md-card-content>
                                                <md-card-actions md-alignment="right">
                                                    <md-button class="md-danger" @click="closeForm()">Close</md-button>
                                                    <md-button type="submit" class="md-success">Add Rate</md-button>
                                                </md-card-actions>
                                            </form>
                                        </md-card>
                                    </div>
<!--                                    <md-table-->
<!--                                            :value="table"-->
<!--                                            :md-sort.sync="sortation.field"-->
<!--                                            :md-sort-order.sync="sortation.order"-->
<!--                                            :md-sort-fn="customSort"-->
<!--                                            class="paginated-table table-striped table-hover"-->
<!--                                    >-->
<!--                                        <md-table-toolbar>-->
<!--                                            <md-field>-->
<!--                                                <label>Per page</label>-->
<!--                                                <md-select v-model="pagination.perPage" name="pages">-->
<!--                                                    <md-option-->
<!--                                                            v-for="item in pagination.perPageOptions"-->
<!--                                                            :key="item"-->
<!--                                                            :label="item"-->
<!--                                                            :value="item"-->
<!--                                                    >-->
<!--                                                        {{ item }}-->
<!--                                                    </md-option>-->
<!--                                                </md-select>-->
<!--                                            </md-field>-->

<!--                                            <md-field>-->
<!--                                                <md-input-->
<!--                                                        v-model="query"-->
<!--                                                        type="search"-->
<!--                                                        class="mb-3"-->
<!--                                                        clearable-->
<!--                                                        style="width: 200px"-->
<!--                                                        placeholder="Search ..."-->
<!--                                                >-->
<!--                                                </md-input>-->
<!--                                            </md-field>-->
<!--                                        </md-table-toolbar>-->

<!--                                        <md-table-row slot="md-table-row" slot-scope="{ item }">-->
<!--                                            <md-table-cell md-label="Activity Name" md-sort-by="activity_id">{{-->
<!--                                                item.activity_name-->
<!--                                                }}-->
<!--                                            </md-table-cell>-->
<!--                                            <md-table-cell md-label="Amount" md-sort-by="amount">{{-->
<!--                                                item.amount-->
<!--                                                }}-->
<!--                                            </md-table-cell>-->
<!--                                            <md-table-cell md-label="Weekend Amount" md-sort-by="weekend_amount">{{-->
<!--                                                item.weekend_amount-->
<!--                                                }}-->
<!--                                            </md-table-cell>-->
<!--                                            <md-table-cell md-label="Active" md-sort-by="is_active">-->
<!--                                                <p v-if="item.is_active">-->
<!--                                                    Yes-->
<!--                                                </p>-->
<!--                                                <p v-else>-->
<!--                                                    No-->
<!--                                                </p>-->
<!--                                            </md-table-cell>-->
<!--                                            <md-table-cell md-label="From" md-sort-by="start_date">{{-->
<!--                                                item.From-->
<!--                                                }}-->
<!--                                            </md-table-cell>-->
<!--                                            <md-table-cell md-label="To" md-sort-by="end_date">{{-->
<!--                                                item.To-->
<!--                                                }}-->
<!--                                            </md-table-cell>-->
<!--                                            <md-table-cell md-label="Actions">-->
<!--                                                <md-button class="md-icon-button md-raised md-round md-danger"-->
<!--                                                        @click="destroy(item.id)"-->
<!--                                                        style="margin: 0.2rem">-->
<!--                                                    <md-icon>delete</md-icon>-->
<!--                                                </md-button>-->
<!--                                            </md-table-cell>-->
<!--                                        </md-table-row>-->
<!--                                    </md-table>-->
<!--                                    <div class="footer-table md-table">-->
<!--                                        <table>-->
<!--                                            <tfoot>-->
<!--                                            <tr>-->
<!--                                                <th-->
<!--                                                        v-for="item in footerTable"-->
<!--                                                        :key="item.name"-->
<!--                                                        class="md-table-head"-->
<!--                                                >-->
<!--                                                    <div class="md-table-head-container md-ripple md-disabled">-->
<!--                                                        <div class="md-table-head-label">-->
<!--                                                            {{ item }}-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </th>-->
<!--                                            </tr>-->
<!--                                            </tfoot>-->
<!--                                        </table>-->
<!--                                    </div>-->
                                </md-card-content>

<!--                                <md-card-actions md-alignment="space-between">-->
<!--                                    <div class="">-->
<!--                                        <p class="card-category">-->
<!--                                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                    <pagination-->
<!--                                            class="pagination-no-border pagination-success"-->
<!--                                            v-model="pagination.currentPage"-->
<!--                                            :per-page="pagination.perPage"-->
<!--                                            :total="total"-->
<!--                                    />-->
<!--                                </md-card-actions>-->
                            </md-card>


                            <!--                                            pagination table ends here-->

                            <hr>
                            <!--               Adding New tariff Rate -->

                                                                        <md-table v-model="activityTariff" @md-selected="onSelect">
                                                                            <md-table-toolbar>
                                                                                <md-field>
                                                                                    <label>Per page</label>
                                                                                    <md-select
                                                                                            v-model="pagination.perPage"
                                                                                            name="pages">
                                                                                        <md-option
                                                                                                v-for="item in pagination.perPageOptions"
                                                                                                :key="item"
                                                                                                :label="item"
                                                                                                :value="item"
                                                                                        >
                                                                                            {{ item }}
                                                                                        </md-option>
                                                                                    </md-select>
                                                                                </md-field>

                                                                                <md-field>
                                                                                    <md-input
                                                                                            v-model="query"
                                                                                            type="search"
                                                                                            class="mb-3"
                                                                                            clearable
                                                                                            style="width: 200px"
                                                                                            placeholder="Search ..."
                                                                                    >
                                                                                    </md-input>
                                                                                </md-field>
                                                                            </md-table-toolbar>
                                                                            <md-table-row>
                                                                                <md-table-cell>
                                                                                    <b>From</b>
                                                                                </md-table-cell>
                                                                                <md-table-cell>
                                                                                    <b>To</b>
                                                                                </md-table-cell>
                                                                                <md-table-cell> <b>Activity</b> </md-table-cell>
                                                                                <md-table-cell> <b>Amount</b> </md-table-cell>
                                                                                <md-table-cell> <b>Weekend Amount</b> </md-table-cell>
                                                                                <md-table-cell> <b>Update</b></md-table-cell>
                                                                                <md-table-cell> <b>Delete</b></md-table-cell>
                                                                            </md-table-row>
                                                                            <md-table-row v-for="rateData in table " :key="rateData.id">
                                                                                <md-table-cell>
                                                                                        {{ rateData.start_date }}
                                                                                </md-table-cell>
                                                                                <md-table-cell>
                                                                                        {{ rateData.end_date }}
                                                                                </md-table-cell>

                                                                                <md-table-cell>
                                                                                    <p>
                                                                                        {{ rateData.activity_name }}
                                                                                    </p>
                                                                                </md-table-cell>
                                                                                <md-table-cell>
                                                                                    <div v-if="rateData.id == editID">
                                                                                        <md-field>
                                                                                        <md-input v-model="rateData.amount"
                                                                                                  :id="rateData.id"/>
                                                                                        </md-field>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        {{ rateData.amount }}
                                                                                    </div>
                                                                                </md-table-cell>
                                                                                <md-table-cell>
                                                                                    <div v-if="rateData.id == editID">
                                                                                        <md-field>
                                                                                        <md-input v-model="rateData.weekend_amount"
                                                                                                  :id="rateData.id"
                                                                                        />
                                                                                        </md-field>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        {{ rateData.weekend_amount }}
                                                                                    </div>
                                                                                </md-table-cell>
                                                                                <md-table-cell>
                                                                                        <div v-if="rateData.id  == editID">
                                                                                            <md-button    @click="updateRateData(rateData)"
                                                                                                    class="md-just-icon md-simple md-primary">
                                                                                                <md-icon>
                                                                                                    save
                                                                                                </md-icon>
                                                                                            </md-button>
                                                                                        </div>

                                                                                        <div v-else @click=setEditingRate(rateData.id)>
                                                                                            <md-button class="md-icon-button md-raised md-round md-info"
                                                                                                    style="margin: 0.2rem">
                                                                                                <md-icon>edit</md-icon>
                                                                                            </md-button>
                                                                                        </div>

                                                                                </md-table-cell>
                                                                                <md-table-cell>
                                                                                    <md-button
                                                                                            class="md-icon-button md-raised md-round md-danger"
                                                                                            @click="destroy(rateData.id)"
                                                                                            style="margin: 0.2rem"
                                                                                    >
                                                                                        <md-icon>delete</md-icon>
                                                                                    </md-button>
                                                                                </md-table-cell>
                                                                            </md-table-row>
                                                                        </md-table>
                                                            <md-card-actions md-alignment="space-between">
                                                                <div class="">
                                                                    <p class="card-category">
                                                                        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                                                                    </p>
                                                                </div>
                                                                <pagination
                                                                        class="pagination-no-border pagination-success"
                                                                        v-model="pagination.currentPage"
                                                                        :per-page="pagination.perPage"
                                                                        :total="total"
                                                                />
                                                            </md-card-actions>
                        </md-tab>
                    </md-tabs>

                </template>
            </nav-tabs-card>
        </div>
    </div>
</template>

<script>
import SelectInput from '../../../components/Inputs/SelectInput';
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert2';
import { NavTabsCard, } from '@/components';

export default {
    components: {
        SelectInput,
        NavTabsCard,
        pagination: Pagination,
    },
    props: {
        profileCard: {
            type: String,
            default: process.env.VUE_APP_BASE_URL + '/img/faces/card-profile1-square.jpg'
        }
    },
    data () {
        return {
            editID: '',
            selected: [],
            improvedRates: [],
            activityList: [],
            tariffActivities: [],
            responsive: false,
            isEditing: false,
            isEditingNewTag: false,
            tariff: {
                type: 'tariffs',
                name: null,
                id: null,
                description: null,
                is_active: null,
            },
            activity: {
                type: 'activities',
                name: null,
                id: null,
                pay_code: null,
                description: null,
                payment_mode: null
            },
            activityTariff: {
                type: 'activityTariffs',
                activity_id: null,
                activity_name: null,
                tariff_id: null,
                tariff_name: null,
                amount: null,
                weekend_amount: null,
                is_active: null,
                id: null
            },
            activityNewRate: {
                type: 'activityTariffs',
                activity_id: null,
                tariff_id: null,
                amount: null,
                weekend_amount: null,
                is_active: null,
            },
            classicModal: false,
            noticeModal: false,
            smallAlertModal: false,
            table: [],
            footerTable: [
                'Tariff',
                'Activity',
                'Amount',
                'Weekend Amount',
                'Active',
                'From',
                'To'
            ],
            query: null,
            sortation: {
                field: null,
                order: 'asc',
            },

            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
            },
            total: 0,
        };
    },
    computed: {
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
    },

    created () {
        this.get();
        this.getActivities();
        this.getTariffActivityRates();
    },


    watch: {
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        sortation: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
    },
    methods: {
        closeForm () {
            this.isEditingNewTag = false;
        },
        async fetchData () {
            let params = {
                filter: {
                    'hasNoTariff': this.tariff.id
                }
            };

            await this.$store.dispatch('activities/list', params);
            this.activityList = this.$store.getters['activities/list'];
        },
        setEditingRate (rateId) {
            this.editID = rateId;
            this.isEditingNewTag = false;
        },
        async updateRateData (rateData) {
            console.log('here we go');
            rateData.type = 'activityTariffs';
            try {
                await this.$store.dispatch('activityTariffs/update', rateData);
                await this.$store.dispatch(
                    'alerts/success',
                    'Activity tariff updated successfully.'
                );
                await this.getList();

                console.log('here we Reach');
                this.editID = '';
            } catch (e) {
                console.log(e);
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
            this.editID = '';
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Tariff', params: { id } });
        },
        onSelect: function (items) {
            this.selected = items;
        },
        onResponsiveInverted () {
            if (window.innerWidth < 768) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('tariffs/get', {id:id});
                this.tariff = this.$store.getters['tariffs/tariff'];
                await this.getList();
                await this.fetchData();
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async getActivities () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('tariffs/activities', id);
                this.activity = this.$store.getters['tariffs/list'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async getTariffActivityRates () {
            let params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                    ...(this.query ? { name: this.query } : {}),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };
            try {
                await this.$store.dispatch('tariffActivities/list', params);
                this.activityTariff = this.$store.getters['tariffActivities/list'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        async update () {
            this.tariff.is_active = 1;
            try {
                await this.$store.dispatch('tariffs/update', this.tariff);
                await this.$store.dispatch(
                    'alerts/success',
                    'Tariff Activated successfully.'
                );
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        goBack () {
            this.$router.push({ name: 'Tariffs List' });
        },
        classicModalHide: function () {
            this.classicModal = false;
        },
        noticeModalHide: function () {
            this.noticeModal = false;
        },
        smallAlertModalHide: function () {
            this.smallAlertModal = false;
        },

        addNewActivityTariffRate () {
            this.isEditingNewTag = true;
        },
        async add () {
            this.isEditingNewTag = false;
            this.activityNewRate.tariff_id = this.tariff.id;
            try {
                await this.$store.dispatch('tariffActivities/add', this.activityNewRate);
                this.notifySuccess('Tariff Activity  Rate added successfully.');
                await this.getList();
                this.activityNewRate.activity_id = null;
                this.activityNewRate.tariff_id = null;
                this.activityNewRate.amount = null;
                this.activityNewRate.weekend_amount = null;
                this.activityNewRate.is_active = null;
                this.reload();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        async destroy (Rate) {
            if (this.$isDemo == 1 && ['1'].includes(Rate)) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default items.'
                );
                return;
            }
            const confirmation = await Swal.fire({
                title: 'Delete this Rate?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                try {
                    await this.$store.dispatch('activityTariffs/destroy', Rate);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Tariff Rate deleted successfully.'
                    );
                    await this.getTariffActivityRates();
                } catch (e) {
                    if (e.response.data.errors[0]) {
                        await this.$store.dispatch(
                            'alerts/error',
                            e.response.data.errors[0].title
                        );
                    } else {
                        this.notifyException(e);
                    }
                }
            }
        },
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

        async getList () {
            let params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                    ...(this.query ? { name: this.query } : {}),
                    ...(this.tariff.id ? { tariff_id: this.tariff.id } : {}),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };

            try {
                await this.$store.dispatch('activityTariffs/list', params);
                this.table = this.$store.getters['activityTariffs/list'];
                this.total = this.$store.getters['activityTariffs/listTotal'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
    },
    mounted () {
        this.onResponsiveInverted();
        window.addEventListener('resize', this.onResponsiveInverted);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResponsiveInverted);
    },

};
</script>

<style lang="css"></style>
